import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { StoriesOverviewMainTeaser } from "./elements/stories-overview-main-teaser";
import { StoriesOverviewStickyTeaser } from "./elements/stories-overview-sticky-teaser";
import { StoriesOverviewTeasers } from "./elements/teasers/stories-overview-teasers";

import { css } from "@emotion/react";
import { CSS_MQ } from "../../../styles/breakpoints";
import { StoriesOverviewSectionType, StoriesOverviewSectionTypeT, type TranslatedValue } from "@swo/storefront";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { ExpandedStoryTeaser } from "../../../layouts/stories/stories-overview-page/stories-overview-page-layout";
import { ExpandedTagT } from "@swo/shared";
import { ActiveTagsList } from "./active-tags-list";
import { T } from "../../T";

export const StoriesOverviewComponent: ReactTFC<{
  elements: Array<StoriesOverviewSectionTypeT<ExpandedStoryTeaser>>;
  activeTags: Array<ExpandedTagT>;
  noMatchingStoriesLabel: TranslatedValue;
}> = props => {
  return (
    <>
      <ActiveTagsList activeTags={props.activeTags} />
      <StoriesList noMatchingStoriesLabel={props.noMatchingStoriesLabel} elements={props.elements} />
    </>
  );
};

const StoriesList: React.FC<{
  elements: Array<StoriesOverviewSectionTypeT<ExpandedStoryTeaser>>;
  noMatchingStoriesLabel: TranslatedValue;
}> = props => {
  if (props.elements.length > 0) {
    return (
      <>
        {props.elements.map((element, idx) => {
          const { mainTeaser, ...groupElements } = element;

          return (
            <React.Fragment key={JSON.stringify(element)}>
              {mainTeaser && <StoriesOverviewMainTeaser {...mainTeaser} />}
              <StoriesOverviewTeaserGroupElement {...groupElements} />
            </React.Fragment>
          );
        })}
      </>
    );
  } else {
    return (
      <p css={[FONTS.SwarovskiFutura300, fontColor.black, fontSize.x2]}>
        <T>{props.noMatchingStoriesLabel}</T>
      </p>
    );
  }
};

const StoriesOverviewTeaserGroupElement: ReactTFC<{
  stickyTeaser: ExpandedStoryTeaser;
  teasers: Array<ExpandedStoryTeaser>;
  layout: StoriesOverviewSectionType["layout"];
}> = props => {
  return (
    <div
      css={css`
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
        ${CSS_MQ.atLeastSm} {
          display: grid;
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
          grid-column-gap: 20px;
          margin-bottom: 30px;
        }
        ${CSS_MQ.atLeastLg} {
          grid-column-gap: 35px;
        }
      `}
    >
      <StoriesOverviewStickyTeaser {...props.stickyTeaser} />
      <StoriesOverviewTeasers teasers={props.teasers} layout={props.layout} />
    </div>
  );
};
